export const capitalizeLetter = (str) => {
  let result = str
    .split("")
    .map((char, index) => (index === 0 ? char?.toUpperCase() : char))
    .join("");
  return result;
};
